<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'BtnLoad',
    inheritAttrs: false,
  });

  const componentMetadata = {
    kind: 'usercontrol',
  };

  const emit = defineEmits(['reload', 'close', 'save', 'click']);

  const props = defineProps({
    action: {
      type: Object,
      required: false,
    },
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const ux = ref([]);

  const $data = computed(() => ({
    ux: ux.value,
  }));

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [{ name: 'ux' }],
    loaders: {},
    ux: {},
    dataRefs: { ux },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  watch(
    () => props.action,
    (newValue, oldValue) => {
      if (_.isEqual(newValue, oldValue)) return;
      loadDataThrottled('action');
    }
  );

  const act_7315092382398562_script_watza3iu8_value_callable = async (
    $event
  ) => {
    return emit('click', $event.originalEvent);
  };
  const act_7315092382398562_script_watza3iu8_getActionArgs = async (
    $event
  ) => {
    return {
      value: async () => {
        await act_7315092382398562_script_watza3iu8_value_callable($event);
      },
    };
  };

  const act_7315092382398562_script_watza3iu8 = new actionTypes.ScriptAction({
    actionArgs: act_7315092382398562_script_watza3iu8_getActionArgs,
  });
  const inst_evh_7315092382398562_click_ryljv0htz =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_script_watza3iu8,
      event: 'click',
      displayName: 'script',
    });
  const inst_evh_7315092382398562_click = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_click_ryljv0htz],
    event: 'click',
  });

  const actions = {
    inst_evh_7315092382398562_click_ryljv0htz,
    inst_evh_7315092382398562_click,
  };

  const evh_7315092382398562_click_ryljv0htz = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_click_ryljv0htz.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_click = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_click.executeFromDOM(
      $component,
      event,
      scope
    );
  };

  defineExpose({
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <ItpButton
    variant="light"
    :icon="$config.reloadIcon"
    :text="pgettext('Button', 'Load')"
    :title="pgettext('Button|Title', 'Load data')"
    :spinning="action.isRunning"
    @click="evh_7315092382398562_click($event, {})"
  >
  </ItpButton>
</template>
